import { ArrowRight, BookOpen } from 'lucide-react'

type Props = {
  currentId: string
  targetId: string
  onOpen: () => void
}

export function ReferenceUpdateNotice({ currentId, targetId, onOpen }: Props) {
  return (
    <section className="reference-update-notice">
      <BookOpen size={21} />
      <div><strong>Une nouvelle référence est disponible</strong><span>{currentId} → {targetId}. Ce projet ne changera pas sans votre décision.</span></div>
      <button onClick={onOpen} type="button">Voir les changements <ArrowRight size={16} /></button>
    </section>
  )
}
